import apiClient from './api';

// apiClient carries the auth interceptor and API base, so use it wherever the Bearer token is needed.

// Login removed. This module no longer provides authentication helpers.

export const getRestaurantProfile = async (restaurantId) => {
  const response = await apiClient.get(`/users/restaurant/${restaurantId}/profile/`);
  return response.data;
};

export const updateRestaurantBasicInfo = async (restaurantId, data) => {
  const response = await apiClient.put(`/users/restaurant/${restaurantId}/basic-info/`, data);
  return response.data;
};

export const updateRestaurantLayout = async (restaurantId, layoutData) => {
  const response = await apiClient.put(`/users/restaurant/${restaurantId}/layout/`, {
    table_layout: layoutData
  });
  if (response.data.success && response.data.data) {
    localStorage.setItem('restaurant', JSON.stringify(response.data.data));
  }
  return response.data;
};

export const getRestaurantFromStorage = () => {
  const restaurant = localStorage.getItem('restaurant');
  return restaurant ? JSON.parse(restaurant) : null;
};

export const removeRestaurantFromStorage = () => {
  localStorage.removeItem('restaurant');
};

export const publishSeatingLayout = async (restaurantId, layoutData) => {
  const response = await apiClient.post(`/users/restaurant/${restaurantId}/seating-layout/`, {
    layout: layoutData
  });
  if (response.data.success && response.data.data) {
    localStorage.setItem('restaurant', JSON.stringify(response.data.data));
  }
  return response.data;
};

export const getSeatingInfo = async (restaurantId) => {
  const response = await apiClient.get(`/users/restaurant/${restaurantId}/seating-info/`);
  return response.data;
};

// New Layout APIs with proper coordinate storage
export const getRestaurantLayout = async (restaurantId) => {
  const response = await apiClient.get(`/users/restaurant/${restaurantId}/layout-data/`);
  return response.data;
};

export const saveRestaurantLayout = async (restaurantId, layoutData) => {
  const response = await apiClient.post(`/users/restaurant/${restaurantId}/save-layout/`, {
    layout: layoutData
  });
  return response.data;
};

export const getAvailableSeats = async (restaurantId, bookingDate, bookingTime, durationMinutes = 120) => {
  const response = await apiClient.get(`/users/restaurant/${restaurantId}/available-seats/`, {
    params: {
      booking_date: bookingDate,
      booking_time: bookingTime,
      duration_minutes: durationMinutes
    }
  });
  return response.data;
};

export const createBooking = async (bookingData) => {
  const response = await apiClient.post(`/users/booking/create/`, bookingData);
  return response.data;
};

export const getRestaurantBookings = async (restaurantId, bookingDate = null) => {
  const params = bookingDate ? { booking_date: bookingDate } : {};
  const response = await apiClient.get(`/users/restaurant/${restaurantId}/bookings/`, { params });
  return response.data;
};
